import { useState, useEffect } from 'react';
import Backdrop from '@mui/material/Backdrop';

const barBase: React.CSSProperties = {
  position: 'absolute',
  width: '9.28572px',
  height: '27.8571px',
  borderRadius: '4.64286px',
  backgroundColor: 'white',
};

export default function Loading() {
  const [colorIndex, setColorIndex] = useState(0);
  const [open] = useState(true);

  useEffect(() => {
    const interval = setInterval(() => {
      setColorIndex((prevIndex) => (prevIndex + 1) % 8);
    }, 100);
    return () => clearInterval(interval);
  }, []);

  return (
    <div>
      <Backdrop
        sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })}
        open={open}
      >
        <div
          style={{
            position: 'relative',
            width: '105px',
            height: '105px',
            opacity: 0.8,
          }}
        >
          {/* 12시 방향 */}
          <div
            style={{
              ...barBase,
              top: 0,
              left: '50%',
              transform: 'translateX(-50%) rotate(0deg)',
              backgroundColor: colorIndex === 0 ? '#5EBEBB' : 'white',
              transition: 'transform 0.8s ease-in-out',
            }}
          />
          {/* 6시 방향 */}
          <div
            style={{
              ...barBase,
              bottom: '0px',
              left: '50%',
              transform: 'translateX(-50%) rotate(0deg)',
              backgroundColor: colorIndex === 4 ? '#5EBEBB' : 'white',
              transition: 'transform 0.8s ease-in-out',
            }}
          />
          {/* 9시 방향 (컬러만 다름) */}
          <div
            style={{
              ...barBase,
              top: '50%',
              left: '10px',
              transform: 'translateY(-50%) rotate(90deg)',
              backgroundColor: colorIndex === 6 ? '#5EBEBB' : 'white',
              transition: 'transform 0.8s ease-in-out',
            }}
          />
          {/* 3시 방향 */}
          <div
            style={{
              ...barBase,
              top: '50%',
              right: '10px',
              transform: 'translateY(-50%) rotate(-90deg)',
              backgroundColor: colorIndex === 2 ? '#5EBEBB' : 'white',
              transition: 'transform 0.8s ease-in-out',
            }}
          />
          {/* 10시 방향 */}
          <div
            style={{
              ...barBase,
              top: '13px',
              left: '20px',
              transform: 'rotate(-48deg)',
              backgroundColor: colorIndex === 7 ? '#5EBEBB' : 'white',
              transition: 'transform 0.8s ease-in-out',
            }}
          />
          {/* 4시 방향 */}
          <div
            style={{
              ...barBase,
              bottom: '13px',
              right: '20px',
              transform: 'rotate(-48deg)',
              backgroundColor: colorIndex === 3 ? '#5EBEBB' : 'white',
              transition: 'transform 0.8s ease-in-out',
            }}
          />
          {/* 8시 방향 */}
          <div
            style={{
              ...barBase,
              bottom: '13px',
              left: '20px',
              transform: 'rotate(-135deg)',
              backgroundColor: colorIndex === 5 ? '#5EBEBB' : 'white',
              transition: 'transform 0.8s ease-in-out',
            }}
          />
          {/* 2시 방향 */}
          <div
            style={{
              ...barBase,
              top: '13px',
              right: '20px',
              transform: 'rotate(-135deg)',
              backgroundColor: colorIndex === 1 ? '#5EBEBB' : 'white',
              transition: 'transform 0.8s ease-in-out',
            }}
          />
        </div>
      </Backdrop>
    </div>
  );
}

